import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ModalService } from '../../../shared/services/modal.service';
import { AdminService } from '../../../shared/services/admin.service';
import { alertMessages, AlertService } from '../../../shared/services/alert.service';
import { SchoolService } from '../../../api/services/school.service';
import { SchoolClass } from '../../../api/models/school-class';
import { empty } from '../../../functions';
import { ModalAdminSchoolClassComponent } from './modal-admin-school-class/modal-admin-school-class.component';

@Component({
    selector: 'app-admin-school-classes',
    templateUrl: './admin-school-classes.component.html',
    standalone: false
})
export class AdminSchoolClassesComponent implements OnInit {

  private readonly route = inject(ActivatedRoute);
  readonly modal = inject(ModalService);
  readonly adminService = inject(AdminService);
  private readonly alertService = inject(AlertService);
  private readonly schoolService = inject(SchoolService);

  schoolId = '';
  schoolName = '';

  configTable = {
    hasPagination: false,
    columns: [
      {
        header_name: 'Name',
        name: 'name',
        type: 'text'
      },
      {
        header_name: 'Grade',
        name: 'grade',
        type: 'text'
      },
      {
        header_name: 'Education level',
        name: 'educationLevel',
        subName: 'name',
        type: 'text'
      },
      {
        header_name: 'Internships allowed',
        name: 'internshipsAllowed',
        type: 'text'
      },
    ],
    endpoint: '',
    data: <any>[],
    buttons: [
      {
        class: 'btn btn-danger',
        event: 'delete',
        text: 'Delete'
      },
      {
        class: 'btn btn-warning',
        event: 'edit',
        text: 'Edit'
      }
    ],
    class: '',
    reloadListener: new Subject(),
    queryParams: {}
  };

  ngOnInit(): void {
    this.schoolId = this.route.snapshot.params['schoolId'];
    this.configTable.endpoint = 'school/' + this.schoolId + '/classes';

    // Load school name for the header
    this.schoolService.getSchool({ id: this.schoolId })
      .pipe(catchError(this.adminService.handleError('getSchool', null)))
      .subscribe((result) => {
        if (result) {
          this.schoolName = result.name;
        }
      });
  }

  addClass() {
    const data = {
      schoolId: this.schoolId,
      entity: null,
    };

    this.modal.Modal(ModalAdminSchoolClassComponent, '', '', data, [], { backdrop: 'static', size: 'lg' }).then((result) => {
      if (result === true) {
        this.alertService.success(alertMessages.successDataSaved);
        this.configTable.reloadListener.next(true);
      }
    }).catch(() => {});
  }

  updateClass($data: SchoolClass) {
    const data = {
      schoolId: this.schoolId,
      entity: $data,
    };

    this.modal.Modal(ModalAdminSchoolClassComponent, '', '', data, [], { backdrop: 'static', size: 'lg' }).then((result) => {
      if (result === true) {
        this.alertService.success(alertMessages.successDataSaved);
        this.configTable.reloadListener.next(true);
      }
    }).catch(() => {});
  }

  deleteClass(id: string) {
    this.modal.Confirm('Delete', 'Are you sure you want to delete this?').then((confirm) => {
      if (confirm === true) {
        this.schoolService.deleteSchoolClass({ schoolId: this.schoolId, id })
          .pipe(catchError(this.adminService.handleError('deleteSchoolClass', false)))
          .subscribe((result) => {
            if (result !== false) {
              this.alertService.success(alertMessages.successDataRemoved);
              this.configTable.reloadListener.next(true);
            }
          });
      }
    }).catch(() => {});
  }

  handleButtonEvent($event: any) {
    if (!empty($event['event'])) {
      switch ($event['event']) {
        case 'edit':
          this.updateClass($event['data']);
          break;
        case 'delete':
          this.deleteClass($event['data']['id']);
          break;
      }
    }
  }
}
